import { Language, nullOrString } from '@proprioo/hokkaido';
import { OptionProps } from '@proprioo/salatim';

import { ContractType } from '../admin/agentAdministration/Agent.interfaces';

export const isValidRegex = (regex: RegExp, value?: nullOrString): boolean =>
  value ? regex.test(value) : true;

export const removeEmoji = (text: string) =>
  text.replace(
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{2B50}]/gu,
    ''
  );

export const addUrlPrefix = (url: nullOrString): string => {
  const linkedinRegex = /^(https:\/\/)?fr\.linkedin\.com\/in\/.+/;

  if (!url) return '';

  // handle specific linkedin url - does not accept "www." prefix
  if (linkedinRegex.test(url)) {
    if (/^https:\/\//.test(url)) {
      return url;
    } else {
      return `https://${url}`;
    }
  }

  if (/^https:\/\/www\./.test(url)) {
    return url;
  }

  if (/^https:\/\//.test(url)) {
    return url.replace('https://', 'https://www.');
  }

  if (/^http:\/\/www\./.test(url)) {
    return url.replace('http://www.', 'https://www.');
  }

  if (/^http:\/\//.test(url)) {
    return url.replace('http://', 'https://www.');
  }

  if (/^www\./.test(url)) {
    return `https://${url}`;
  }

  return `https://www.${url}`;
};

export const languageOptions: OptionProps[] = [
  { label: 'english', value: Language.ENGLISH },
  { label: 'french', value: Language.FRENCH },
  { label: 'italian', value: Language.ITALIAN },
  { label: 'spanish', value: Language.SPANISH }
];

export const getContractTypeLabel = (contractType: ContractType) => {
  switch (contractType) {
    case ContractType.AGENTCO:
      return 'agentCo';
    case ContractType.CDI:
      return 'cdi';
    case ContractType.IREC:
      return 'irec';
  }
};
